import React, { useEffect, useState, useMemo } from "react";
import Table from "../common/Table";
import PageHeader from "../common/PageHeader";
import fetchData from "../../api/fetchApi";
import { useNavigate } from "react-router-dom";
import DatePickerModal from "../common/DatePickerModal";
import { ArrowUpDown } from "lucide-react";

export default function MembersPage() {
  const [members, setMembers] = useState([]);
  const [totalMembers, setTotalMembers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [packages, setPackages] = useState([]);
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    mobile: "",
    status: "",
    package_id: "",
    not_expired: "",
    expire_in_day: "",
    expire_in_month: "",
    expire_in_year: "",
    not_trial: "",
    last_login_at_not: ""
  });
  const [sort, setSort] = useState("-id");
  const navigate = useNavigate();

  const refreshMembers = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      params.set("page", currentPage);
      params.set("per_page", perPage);
      params.set("sort", sort);
      
      // Handle filters
      Object.entries(filters).forEach(([key, value]) => {
        if (value == '') {

        } else {
          params.set(`filter[${key}]`, value ?? "");
        }
     
   
       
        
      });
  const data = await fetchData(`chaat/members?${params.toString()}`);
  const membersData = data.data || [];
  setMembers(membersData);
  setTotalMembers(data.meta?.total ?? membersData.length);
  setCurrentPage(data.meta?.current_page || currentPage);
  setTotalPages(data.meta?.last_page || 1);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshMembers();
    fetchData("chaat/packages").then(data => setPackages(data.data || []));
    // eslint-disable-next-line
  }, [filters, currentPage, perPage, sort]);

  const handleSortChange = (value) => {
    setSort(value);
    setCurrentPage(1);
  };
  const sortableHeader = (label, sortValue) => (
    <div 
      className="flex items-center gap-2 group cursor-pointer" 
      onClick={(e) => {
        e.stopPropagation();
        handleSortChange(sortValue);
      }}
    >
      <span>{label}</span>
      <button
        type="button"
        className={`p-1 rounded-full text-xs transition-all ${
          sort === sortValue 
            ? "bg-[#1D2035] text-white opacity-100" 
            : "text-gray-400 hover:bg-gray-100 opacity-0 group-hover:opacity-100"
        }`}
        onClick={(e) => {
          e.stopPropagation();
          handleSortChange(sortValue);
        }}
      >
        <ArrowUpDown size={14} />
      </button>
    </div>
  );

  const columns = useMemo(
    () => [
      { header: sortableHeader("الرقم التعريفي", "-id"), accessor: "id" },
      { header: sortableHeader("الاسم", "-name"), accessor: "name" },
      { header: sortableHeader("البريد الإلكتروني", "email"), accessor: "email" },
      { header: "رقم الهاتف", accessor: "mobile" },
      { header: "الحالة", accessor: "status", render: row => row.status === "1" ? "نشط" : "غير نشط" },
      { header: "الباقة", accessor: "package", render: row => row.package ? row.package.package_name : "-" },
      { header: "تاريخ الانتهاء", accessor: "expired_date_at" },
      { header: sortableHeader("آخر دخول", "-last_login_at"), accessor: "last_login_at" },
      { header: "بوت؟", accessor: "bot_status", render: row => row.bot_status === "1" ? "نعم" : "لا" },
      { header: "حسابات", accessor: "accounts", render: row => Array.isArray(row.accounts) && row.accounts.length > 0 ? row.accounts.map(acc => `${acc.balance} ${acc.currency?.symbol || ''}`).join(", ") : "-" },
      { header: "حساب نشط؟", accessor: "has_active_account", render: row => row.has_active_account ? "نعم" : "لا" },
    ],
    [packages, sort]
  );
const [datePickerOpen, setDatePickerOpen] = useState(false);
const [dateRange, setDateRange] = useState({ from: "", to: "" });



  const handleDateApply = (start, end) => {
    const formatDate = (d) => d.toISOString().split('T')[0];
    setDateRange({ from: formatDate(start), to: formatDate(end) });
   
    setFilters(prev => ({
      ...prev,
       expired_date_start: formatDate(start),
       expired_date_end: formatDate(end),
       // Reset other expiration filters
       not_expired: "",
       expire_in_day: "",
       expire_in_month: "",
       expire_in_year: ""
    }));
    setCurrentPage(1);
  };

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
        <DatePickerModal
        isOpen={datePickerOpen}
        onClose={() => setDatePickerOpen(false)}
        onApply={handleDateApply}
       
      />
        <PageHeader title="إجمالي الأعضاء" total={totalMembers} stats={[]}>
              <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
                <span className="inline-block rotate-180">↕</span>
                من الاحدث إلى الأقدم
              </button>
              <button
                onClick={() => setFilters(prev => ({ ...prev, not_trial: prev.not_trial ? "" : "1" }))}
                className={`px-3 py-2 rounded-lg border border-gray-200 text-xs flex items-center gap-2 transition-colors ${filters.not_trial ? 'bg-[#1D2035] text-white' : 'bg-white text-[#1D2035]'}`}
              >
                غير تجريبي
              </button>
              <button
                onClick={() => setFilters(prev => ({ ...prev, last_login_at_not: prev.last_login_at_not ? "" : "0000-00-00 00:00:00" }))}
                className={`px-3 py-2 rounded-lg border border-gray-200 text-xs flex items-center gap-2 transition-colors ${filters.last_login_at_not ? 'bg-[#1D2035] text-white' : 'bg-white text-[#1D2035]'}`}
              >
                لم يسجل دخول أبداً
              </button>
              <button
                onClick={() => setDatePickerOpen(true)}
                className="px-3 py-3 rounded-lg border border-gray-200 bg-white text-xs text-[#1D2035] flex items-center gap-2"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="4" width="18" height="18" rx="2" stroke="#6b7280" />
                  <line x1="8" y1="2" x2="8" y2="6" stroke="#6b7280" />
                  <line x1="16" y1="2" x2="16" y2="6" stroke="#6b7280" />
                  <line x1="3" y1="10" x2="21" y2="10" stroke="#6b7280" />
                </svg>
                {dateRange.from ? `${dateRange.from} - ${dateRange.to}` : "تحديد فترة"}
              </button>
             
            </PageHeader>
         
     
 
      <div className="mt-5">
        <Table
          columns={columns.map(col => {
            if (["status", "package_id"].includes(col.accessor)) {
              if (col.accessor === "status") {
                return { ...col, filterType: 'select', options: [
                  { value: '', label: 'الكل' },
                  { value: '1', label: 'نشط' },
                  { value: '0', label: 'غير نشط' },
                ] };
              }
              if (col.accessor === "package_id") {
                return { ...col, filterType: 'select', options: [
                  { value: '', label: 'الكل' },
                  ...packages.map(pkg => ({ value: pkg.id, label: pkg.package_name }))
                ] };
              }
            }
            return col;
          })}
          rows={members}
          pagination={{
            title: "الأعضاء",
            label: `الصفحة ${currentPage} من ${totalPages}`,
            pages: Array.from({ length: totalPages }, (_, i) => i + 1),
            current: currentPage,
            last: totalPages,
            onPageChange: setCurrentPage,
            perPage: perPage,
            onPerPageChange: setPerPage,
          }}
          act={[
            {
              label: <span className="text-blue-600">عرض</span>,
              onClick: (row) => navigate(`/admin/members/${row.id}`)
            },
            
          ]}
          filters={filters}
          setFilters={setFilters}
          onFilter={refreshMembers}
        />
        {loading && <div className="text-center mt-4">جاري التحميل...</div>}
        {error && <div className="text-red-600 text-center mt-4">{error}</div>}
      </div>
    </div>
  );
}
